import Spinner from "../Spinner";

const ErrorComp = ({ error }: { error: string }) => {
  return (
    <div
      data-testid="capture-dialog-output-error"
      className="capture-dialog-output-error"
    >
      Error! <p>{error}</p>
    </div>
  );
};

interface CaptureDialogOutputProps {
  error: Error | null;
  canvasRef: React.RefObject<HTMLDivElement | null>;
  loaded: boolean;
}

export const CaptureDialogOutput = ({
  error,
  canvasRef,
  loaded,
}: CaptureDialogOutputProps) => {
  return (
    <div className="capture-dialog-output-wrapper">
      {error && <ErrorComp error={error.message} />}
      {loaded ? (
        <div
          ref={canvasRef}
          style={{ opacity: error ? "0.15" : 1 }}
          className="capture-dialog-output-canvas-container"
        />
      ) : (
        <Spinner size="2rem" />
      )}
    </div>
  );
};
